import React from "react";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import * as view from '../views';
import * as Rout from '../constants/routes';
import Desktoplayout from "../layout/Desktoplayout";
import TrackbyReferenceid from "../components/Myaccount/TrackbyReferenceid";
import Trackorderbyid from "../components/Myaccount/Trackorderbyid";
import { ScrollTop } from '../hooks';
import Cookies from "js-cookie";
import Notlogin from "../components/Common/Notlogin"
const AppRoutes = () => {
    return (
        <Router>
            <Routes>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Home />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.Home}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Category />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.category}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Resetpassword />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.Resetpassword}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.ProductCategory />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.products_subcategory}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.ProductCategory />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.brands}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.ProductCategory />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.brands1}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Paymentfail />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.Paymentfail}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Ordersuccess />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.ordesuccess}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Tabbyplan />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.Tabbyplan}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.ProductCategory />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.search_result}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.ProductCategory />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.products_category}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.MyAccount /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.myaccount}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.MobileProfileView /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.myaccount_profile}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.MyWishList />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.mywishlist}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.PasswordChange /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.changepassword}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.Ordertrack /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.trackyourorder}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <Trackorderbyid /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.trackyourorderid}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <TrackbyReferenceid /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.trackyourorderreference}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.Complaints /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.complaints}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.Placecomplaints /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.Placecomplaints}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.ManageComplaints /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.manageComplaint}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.Complaintsuccss /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.Complaintsuccss}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.MyAddress /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.address}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.Cart />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.cart}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.Sitemap />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.sitemap}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Sellwithus />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.Sellwithus}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Warienty />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.Warienty}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.Aboutus />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.Aboutus}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.Contactus />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.Contactus}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.PrivacyPolicy />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.privacypolicy}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.Blogs />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.blogs}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.BlogpageCategory />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.blogscat}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.BlogDetail />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.blogDetail}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.Termandcondition />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.termsandconditions}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.FAQs />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.faqs}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>

                                <view.Affiliateprogram />
                            </Desktoplayout>
                        </ScrollTop>

                    }
                    path={Rout.Affiliateprogram}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.Address /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.delivertaddress}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.Myorder /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.myorders}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.ProductDetail />
                            </Desktoplayout>
                        </ScrollTop>


                    }
                    path={Rout.product_details}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                {
                                    Cookies.get("jwt_token") !== undefined ?
                                        <view.Payment /> : <Notlogin />
                                }

                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.Payment}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes/>
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.perfumes}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes/>
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.bundle_deals}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.tv_super_Sale}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes/>
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.bhd_price}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes/>
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.omr_price}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes/>
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.khd_price}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes/>
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.qar_price}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes/>
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.aed_price}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.timefest}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.bundledeals}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.DealoftheDay />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.deals_of_the_day}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.ClearenceSale />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.clearance_sale}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.TopSelling />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.top_selling}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes  />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.mobilefest}
                >
                </Route>
                <Route
                    element={
                        <ScrollTop>
                            <Desktoplayout>
                                <view.Perfumes  />
                            </Desktoplayout>
                        </ScrollTop>
                    }
                    path={Rout.saverzone}
                >
                </Route>
            </Routes>
        </Router>
    )
}
export default AppRoutes;